<template>
    <div class="wrap">
        <base-table
                :base-url="urlWithFilters"
                ref="baseTable"
                @load-success="onLoadSuccess"
                @load-error="onLoadError"
                @refresh="onRefresh"
                :current-page="currentPage"
                v-loading="isRefreshing"
                element-loading-spinner="el-icon-loading"
        >
            <el-table
                    :data="items"
                    stripe
                    class="w-100"
            >
                <el-table-column type="expand" v-slot="{row}">
                    <expand-column :row="row"></expand-column>
                </el-table-column>
                <el-table-column
                        label="Contact"
                        prop="contact"
                        min-width="250"
                        :formatter="formatFullName"
                ></el-table-column>
                <el-table-column
                        label="Contact's Message"
                        prop="contact.message_created_at"
                        min-width="140"
                        :formatter="formatDate"
                ></el-table-column>
                <el-table-column
                        label="Contact's Message Excerpt"
                        prop="contact.message_excerpt"
                        min-width="350"
                        v-slot="{row: {contact: {message_excerpt}}}"
                >
                    <div class="message-content">{{ message_excerpt }}</div>
                </el-table-column>
                <el-table-column
                        label="Outgoing Number"
                        min-width="250"
                        prop="outgoing_number"
                        :formatter="formatOutgoingNumber"
                ></el-table-column>
                <el-table-column
                        label="Staff's Response"
                        prop="staff.message_created_at"
                        min-width="140"
                        :formatter="formatDate"
                ></el-table-column>
                <el-table-column
                        label="Response Lag"
                        prop="answer_lag"
                        min-width="100"
                ></el-table-column>
            </el-table>
        </base-table>
        <el-pagination
                layout="prev, pager, next"
                :total="total"
                :current-page.sync="currentPage"
                :page-size="pageSize"
                class="text-right"
        ></el-pagination>
    </div>
</template>

<script>
  import TableWithPagination from '../../components/table-with-pagination';
  import {addQueryParams} from '../../libs/url';
  import ExpandColumn from './expand-column';

  export default {
    extends: TableWithPagination,

    components: {
      ExpandColumn,
    },

    props: {
      params: Object,
    },

    data() {
      return {
        filters: {},
      };
    },

    computed: {
      /**
       * @return {string}
       */
      urlWithFilters() {
        return addQueryParams(this.url, _.assign({}, this.filters, this.params));
      },
    },

    methods: {
      /**
       * @param {object} row
       * @param {object} col
       * @param {object} contact
       * @return {string}
       */
      formatFullName(row, col, {first_name = '', last_name = '', phone_number = ''}) {
        return `${first_name} ${last_name} (${phone_number})`
      },

      /**
       * @param {object} row
       * @param {object} col
       * @param {object} date
       * @return {string}
       */
      formatDate(row, col, date) {
        return date ? moment(date.datetime).format('ddd, MMM Do YY, HH:mm') : '-';
      },

      /**
       * @param {object} row
       * @param {object} col
       * @param {string} title
       * @param {string} phone_number
       * @return {string}
       */
      formatOutgoingNumber(row, col, {title, phone_number}) {
        return `${title} (${phone_number})`;
      },

      /**
       * @param {Array} items
       * @param {Number} total
       * @param {Number} currentPage
       * @param {Number} pageSize
       */
      onLoadSuccess({items, meta: {current_page: currentPage, per_page: pageSize, total}}) {
        this.items = items;
        this.total = total;
        this.currentPage = currentPage;
        this.pageSize = pageSize;
        this.$emit('success');
      },

      /**
       * @param error
       * @emits validation-error
       */
      onLoadError({response: {status, data}}) {
        if (status === 422) {
          this.$emit('validation-error', data.errors || {});
        }
      },
    }
  }
</script>
